import React from 'react';

/**
 * Creates a lazy-loaded component with retry capability
 * @param {Function} importFn - Dynamic import function
 * @param {number} retries - Number of retry attempts (default: 3)
 * @param {React.Component} fallbackModule - Optional fallback component to render after retries are exhausted
 * @returns {React.LazyExoticComponent}
 */
export function lazyWithRetry(importFn, retries = 3, fallbackModule = null) {
  return React.lazy(() => {
    return new Promise((resolve, reject) => {
      const attempt = (retriesLeft) => {
        importFn()
          .then(resolve)
          .catch((error) => {
            if (retriesLeft > 0) {
              setTimeout(() => attempt(retriesLeft - 1), 1000);
            } else {
              if (fallbackModule) {
                resolve({ default: fallbackModule });
              } else {
                reject(error);
              }
            }
          });
      };
      attempt(retries);
    });
  });
}
